<template>
    <div class="content-wrapper">
        <section class="content-header">
            <h1>
                Administration
                <small></small>
            </h1>
            <ol class="breadcrumb">
                <li><a href="#"><i class="fa fa-dashboard"></i> Accueil</a></li>
                <li class="active"><a href="#">Administration</a></li>
            </ol>
        </section>
        <section class="content">
            <div class="row">
                <div class="col-md-6" v-for="user in users">
                    <div class="box box-primary">
                        <div class="box-header with-border">
                            <h3 class="box-title">
                                {{user.name}}
                            </h3>
                        </div>
                        <div class="box-body">
                            <div class="form-group" v-for="role in roles">
                                <div class="checkbox">
                                    <label :for="role.id+'_'+user.id">
                                        <input :id="role.id+'_'+user.id"
                                               type="checkbox"
                                               :value="role.id"
                                               v-model="getUserRole(user.id,role.id).roles"
                                        >
                                        {{role.name}}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="box-footer">
                            <a @click.prevent="saveRoles(user.id)" class="pull-right btn btn-primary btn-flat">Sauvegarder</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import {ErrorBag} from 'vee-validate';

    var $ = require('jquery');
    var _ = require('underscore')
    var moment = require('moment')

    export default {
        data() {
            return {
                users: [],
                roles: [],
                users_roles: []
            }
        },
        computed: {
            ...mapGetters({
                getRoute: 'getRoute',
            }),
        },
        mounted: function () {
            var these = this
            this.$nextTick(function () {
                these.getAllUsers();
                these.getAllRoles();
            })
        },
        methods: {
            getUserRole: function (id_user) {
                return _.find(this.users_roles, {id_user: id_user})
            },
            setUserRole: function () {
                this.users.forEach(item => {
                    this.users_roles.push({
                        id_user: item.id,
                        roles: _.pluck(item.roles, 'id')
                    })
                })
            },
            saveRoles: function (id_user) {
                let self=this;
                let user_role = _.find(this.users_roles, {id_user: id_user})
                this.$http.post(this.getRoute('updateRole'), {user_role: user_role}).then(function (response) {
                    self.$noty.success("Roles mises à jour")
                }, (response) => {
                    self.$noty.error("Erreur dans la mise à jour de la roles")
                });
            },
            getAllUsers: function () {
                this.$http.post(this.getRoute('getAllUsers'),{scope:"intranet"}).then((response) => {
                    this.users = response.body
                    this.setUserRole();
                }, (response) => {
                });
            },
            getAllRoles: function () {
                this.$http.get(this.getRoute('getAllRole')).then((response) => {
                    this.roles = response.body
                }, (response) => {
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Administration/Administration.vue